<template>
  <div :class="[b(), className]" :style="styleSizeName">
    <div :ref="id" :style="styleChartName">
      <Earth ref="3dRef" :thisArg="thisArg" :option="option" :prop="prop" :isDataCenter="isDataCenter"
             :dataChart="dataChart"></Earth>
    </div>
  </div>
</template>

<script>
import Earth from './earth.vue';
import sheet from "@/components/Sheet/index.vue";

export default {
  name: "EarthMap",
  data() {
    return {};
  },
  components: {
    sheet,
    Earth
  },
  computed: {
    thisArg() {
      return this
    },
    schema() {
      return {prop: {...this.option, ...this.prop}, themeCfg: this.themeCfg};
    },
  },
  watch: {
    width() {
      this.resizeEarth();
    },
    height() {
      this.resizeEarth();
    }
  },
  methods: {
    resizeEarth() {
      this.$refs["3dRef"]?.resize();
    },
    updateChart() {
      this.$refs["3dRef"]?.updateChart();
    },
  },
};
</script>
